import BannerAward2024 from '../img/banner/Award2024.png';
import Title_Section1 from '../img/event/2512/title.jpg';
import Online_Session from '../img/event/2511/online-session.png';
import { DoubleLineWithCursorButton, DoubleLineButton } from './common/Button';
import { TextBox } from './common/TextBox';
const HomeschoolEvent202511 = () => {
  return (
    <>
      {/* 배너 영역 */}
      <img src={BannerAward2024} alt="Award2024" className="m-auto w-full" />
      {/* 프로모션 섹션 1 */}
      {/* 대지 */}
      <div className="flex items-center justify-center overflow-hidden bg-[#011901]">
        {/* 2. 실제 컨텐츠 레이어 : 배경 레이어 위에 표시됨 */}
        <div className="m-auto flex max-w-[720px] flex-col gap-10 px-5 py-14 sm:gap-20 sm:py-20">
          <div className="flex flex-col items-center justify-center">
            {/* 타이틀 섹션 */}
            <div className="flex flex-col items-center justify-center">
              {/* 타이틀 - 이미지 */}
              <div className="m-auto flex flex-col">
                <img
                  src={Title_Section1}
                  alt="감사로 여는 새해 준비의 골든타임"
                />
              </div>
            </div>

            {/* 말풍선 섹션 */}
            <section className="mx-auto flex flex-col items-center justify-center gap-3 text-lg font-semibold sm:gap-5">
              {/* 말풍선 1 */}
              <div className="flex w-full items-center justify-center gap-6 rounded-2xl bg-[#F3F2E1] px-6 py-6 sm:rounded-3xl sm:px-10 sm:py-5">
                <p className="text-center text-base font-medium text-[#0D0D0D] sm:text-lg">
                  가정 · 공부방 · 대안학교 적용
                  <span className="font-bold"> 100% 가능</span>
                </p>
              </div>
              {/* 말풍선 2 */}
              <div className="flex w-full items-center justify-center gap-6 rounded-2xl bg-[#F3F2E1] px-6 py-6 sm:rounded-3xl sm:px-10 sm:py-5">
                <p className="text-center text-base font-medium text-[#0D0D0D] sm:text-lg">
                  누구나 가르칠 수 있는
                  <span className="font-bold"> 교사용 키트 제공</span>
                </p>
              </div>
              {/* 말풍선 3 */}
              <div className="flex w-full items-center justify-center gap-6 rounded-2xl bg-[#F3F2E1] px-6 py-6 sm:rounded-3xl sm:px-10 sm:py-5">
                <p className="text-center text-base font-medium text-[#0D0D0D] sm:text-lg">
                  <span className="font-bold">12월 등록 시,</span> 성탄 특별
                  페이백 혜택 &<br />
                  <span className="font-bold">
                    2026 가격 인상 전 마지막 금액
                  </span>
                </p>
              </div>
            </section>
          </div>

          {/* 설명회 섹션 */}
          <div className="m-auto flex max-w-[480px] flex-col gap-5">
            {/* 타이틀 */}
            <section className="flex flex-col text-center sm:gap-1">
              {/* 서브타이틀 텍스트 */}
              <div className="text-xl font-semibold text-[#FFD75F] sm:text-2xl">
                젭스홈스쿨의 A-Z까지 한 눈에!
              </div>
              {/* 타이틀 텍스트 */}
              <div className="text-2xl font-extrabold text-white sm:text-4xl">
                어디서든 시청할 수 있는 설명회
              </div>
            </section>

            {/* 이미지 */}
            <div className="relative m-auto w-full">
              <img src={Online_Session} alt="젭스영어성경홈스쿨 온라인설명회" />
            </div>

            {/* 버튼 */}
            <DoubleLineButton
              onClick={() => {
                window.open('https://forms.gle/hYg6Q4YQ4tMcBFb58');
              }}
              borderColor="border-white"
              bgColor="bg-black"
              hoverBgColor="hover:bg-black/70"
              textColor="text-white"
            >
              <div className="p-3 text-xl font-bold sm:p-5 sm:text-4xl">
                지금 설명회 신청하기
              </div>
            </DoubleLineButton>
          </div>
        </div>
      </div>

      {/* 프로모션 섹션 3 */}
      <div className="flex items-center justify-center bg-[#033F26]">
        {/* 2. 실제 컨텐츠 레이어 : 배경 레이어 위에 표시됨 */}
        <div className="m-auto flex max-w-[720px] flex-col gap-10 px-5 py-14 sm:gap-20 sm:py-20">
          {/* 타이틀 영역 */}
          <div className="flex flex-col items-center justify-center gap-5">
            {/* 타이틀 */}
            <p className="text-center text-2xl font-extrabold text-[#FFC450] sm:text-4xl">
              복음을 제대로 아는
              <br /> 아이로 만들기 위해
              <br /> 모든 것을 담았습니다.
            </p>
            {/* 서브타이틀 */}
            <p className="text-md text-center font-medium text-white sm:text-2xl">
              성경스토리 → 청크 학습 → 스피킹 → 발표까지
              <br /> 한 달에 완성되는 유일한 코스! <br /> 바로 젭스 홈스쿨입니다
            </p>
          </div>
          {/* 박스 */}
          <section className="flex w-full flex-col gap-5 sm:gap-8">
            <div className="grid auto-rows-fr grid-cols-1 gap-5">
              <TextBox className="h-full">
                <p className="text-xl font-extrabold text-black md:text-3xl">
                  청크로 배우는{' '}
                  <span className="text-[#2B492A]">말문이 터지는 영어</span>
                </p>
              </TextBox>
              <TextBox className="h-full">
                <p className="text-xl font-extrabold text-black md:text-3xl">
                  발명특허 받은 교수법으로
                  <br />
                  <span className="text-[#2B492A]">
                    성경 스토리를 확실하게 암송
                  </span>
                </p>
              </TextBox>
              <TextBox className="h-full">
                <p className="text-xl font-extrabold text-[#2B492A] md:text-3xl">
                  스토리텔링 & 발표 학습
                </p>
              </TextBox>
            </div>
          </section>

          {/* 버튼 */}
          <DoubleLineWithCursorButton
            onClick={() => {
              window.open('https://jebs.kr/shop/details/NKyRTHjIgiewcumT');
            }}
            bgColor="bg-black"
            hoverBgColor="hover:bg-black/70"
            textColor="text-white"
          >
            <div className="p-3 text-xl font-bold sm:p-5 sm:text-4xl">
              12월 등록 혜택 확인
            </div>
          </DoubleLineWithCursorButton>
        </div>
      </div>
    </>
  );
};

export default HomeschoolEvent202511;
